import { SelectInputV2, SelectInputV2Props } from '@frontend/basic-forms';
import { TransactionStateName } from '@frontend/transaction/types';
import React from 'react';

import useTransactionStateSelect from './transaction-state-select-bs.controller';

const ID = 'transaction-state-select';
export interface TransactionStateSelectProps extends Omit<SelectInputV2Props<TransactionStateName>, 'options'> {
    subset?: string[];
}

/**
 * 
 * @deprecated
 */
export const TransactionStateSelect = (props: TransactionStateSelectProps) => {
    const viewProps = useTransactionStateSelect(props);
    return (
        <SelectInputV2<TransactionStateName>
            {...props}
            id={ID + props.id}
            label={props.label || 'Transaction state'}
            options={viewProps.options}
        />
    );
};
